import { render } from "./BlogPage.vue?vue&type=template&id=11f8170a&scoped=true"
const script = {}

import "./BlogPage.vue?vue&type=style&index=0&id=11f8170a&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f8170a"]])

export default __exports__